var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TeamBuilder',{attrs:{"mode":_vm.$route.params.mode}})}
var staticRenderFns = []

export { render, staticRenderFns }